<script lang="ts">
	import PageGrid16 from '../components/pageGrid16.svelte';
	import HorizontalScrollContainer from '$lib/horizontalScrollContainer.svelte';
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';
	import Blok from '../blok.svelte';

	interface Props {
		content: ISbStoryData<{
			title: string;
			subtitle: string;
			gallery_blocks: ISbStoryData[];
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<section use:editable={content} class="my-12 lg:my-14">
	<PageGrid16>
		<div
			class="col-span-full mb-6 text-center text-brown-1 max-lg:mx-5 lg:col-start-2 lg:col-end-[16] lg:mb-14"
		>
			<h1
				class="text-pretty text-[44px]/[108%] tracking-[-.44px] lg:text-[64px]/[104%] lg:tracking-[-.64px]"
			>
				{content.title}
			</h1>
			<h2
				class="mt-3 text-pretty text-[16px]/[150%] tracking-[-.16px] text-brown-4 lg:mx-8 lg:mt-5 lg:text-[20px]/[140%] lg:tracking-[-.2px]"
			>
				{content.subtitle}
			</h2>
		</div>
	</PageGrid16>

	<div class="flex flex-col gap-y-3 px-3 lg:hidden">
		{#each content.gallery_blocks as item, index}
			<Blok content={item} {index} />
		{/each}
	</div>

	<HorizontalScrollContainer class="max-lg:hidden" offset={20}>
		<div class="slide-wrapper flex h-full gap-x-5 px-5 lg:py-5">
			{#each content.gallery_blocks as item, index}
				<Blok content={item} {index} />
			{/each}
		</div>
	</HorizontalScrollContainer>
</section>

<style>
	div.slide-wrapper {
		height: calc(100vh - var(--full-header-height));
	}
</style>
